import { FC, ReactNode } from "react";

type Props = {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
};

/** Consistent page title block (Phase 2 — adopt on all routes). */
export const EvoPageHeader: FC<Props> = ({ title, subtitle, actions }) => {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold tracking-tight text-[var(--evo-text)] sm:text-[1.625rem]">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-1 text-sm text-[var(--evo-text-secondary)]">{subtitle}</p>
        ) : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
};
